/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSearchOperator } from './InternalApiSearchOperator';
import {
    InternalApiSearchOperatorFromJSON,
    InternalApiSearchOperatorFromJSONTyped,
    InternalApiSearchOperatorToJSON,
    InternalApiSearchOperatorToJSONTyped,
} from './InternalApiSearchOperator';
import type { InternalApiAttributeType } from './InternalApiAttributeType';
import {
    InternalApiAttributeTypeFromJSON,
    InternalApiAttributeTypeFromJSONTyped,
    InternalApiAttributeTypeToJSON,
    InternalApiAttributeTypeToJSONTyped,
} from './InternalApiAttributeType';

/**
 * 
 * @export
 * @interface InternalApiSearchFilter
 */
export interface InternalApiSearchFilter {
    /**
     * 
     * @type {string}
     * @memberof InternalApiSearchFilter
     */
    attributeIdentifier: string;
    /**
     * 
     * @type {InternalApiAttributeType}
     * @memberof InternalApiSearchFilter
     */
    attributeType: InternalApiAttributeType;
    /**
     * 
     * @type {InternalApiSearchOperator}
     * @memberof InternalApiSearchFilter
     */
    operator: InternalApiSearchOperator;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiSearchFilter
     */
    not: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalApiSearchFilter
     */
    query?: string;
}



/**
 * Check if a given object implements the InternalApiSearchFilter interface.
 */
export function instanceOfInternalApiSearchFilter(value: object): value is InternalApiSearchFilter {
    if (!('attributeIdentifier' in value) || value['attributeIdentifier'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    if (!('operator' in value) || value['operator'] === undefined) return false;
    if (!('not' in value) || value['not'] === undefined) return false;
    return true;
}

export function InternalApiSearchFilterFromJSON(json: any): InternalApiSearchFilter {
    return InternalApiSearchFilterFromJSONTyped(json, false);
}

export function InternalApiSearchFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSearchFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeIdentifier': json['attributeIdentifier'],
        'attributeType': InternalApiAttributeTypeFromJSON(json['attributeType']),
        'operator': InternalApiSearchOperatorFromJSON(json['operator']),
        'not': json['not'],
        'query': json['query'] == null ? undefined : json['query'],
    };
}

export function InternalApiSearchFilterToJSON(json: any): InternalApiSearchFilter {
    return InternalApiSearchFilterToJSONTyped(json, false);
}

export function InternalApiSearchFilterToJSONTyped(value?: InternalApiSearchFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attributeIdentifier': value['attributeIdentifier'],
        'attributeType': InternalApiAttributeTypeToJSON(value['attributeType']),
        'operator': InternalApiSearchOperatorToJSON(value['operator']),
        'not': value['not'],
        'query': value['query'],
    };
}

